var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6847 37.2313C55.598 37.1633 54.788 36.56 53.0794 36.56C52.628 36.562 52.178 36.6 51.7334 36.674C51.4027 34.438 49.5874 33.3873 49.5034 33.3387L49.0447 33.0773L48.7427 33.5067C48.3647 34.084 48.0307 34.68 47.8687 35.3487C47.5627 36.6253 47.7487 37.824 48.406 38.8487C47.6114 39.2853 46.2574 39.324 46 39.3333H25.0547C24.504 39.334 24.0574 39.7733 24.054 40.316C24.0294 42.138 24.2894 44.018 24.9247 45.7287C25.6507 47.6073 26.7314 48.9913 28.1367 49.838C29.7114 50.7893 32.27 51.3333 35.1707 51.3333C36.4807 51.3373 37.7887 51.2207 39.0767 50.984C40.8674 50.6593 42.5907 50.042 44.1747 49.1573C45.48 48.4113 46.6547 47.4627 47.654 46.3473C49.324 44.482 50.3187 42.4053 51.0587 40.5593C51.158 40.5593 51.2574 40.5593 51.3534 40.5593C53.182 40.5593 54.306 39.8373 54.926 39.2327C55.338 38.8467 55.66 38.3767 55.8687 37.856L56 37.4773L55.6847 37.2313Z",
    fill: "#2395EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3334 38.6667H27.3334C26.9654 38.6667 26.6667 38.368 26.6667 38V36C26.6667 35.632 26.9654 35.3333 27.3334 35.3333H29.3334C29.7014 35.3333 30 35.632 30 36V38C30 38.368 29.7014 38.6667 29.3334 38.6667Z",
    fill: "#2395EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3334 38.6667H31.3334C30.9654 38.6667 30.6667 38.368 30.6667 38V36C30.6667 35.632 30.9654 35.3333 31.3334 35.3333H33.3334C33.7014 35.3333 34 35.632 34 36V38C34 38.368 33.7014 38.6667 33.3334 38.6667Z",
    fill: "#2395EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3334 38.6667H35.3334C34.9654 38.6667 34.6667 38.368 34.6667 38V36C34.6667 35.632 34.9654 35.3333 35.3334 35.3333H37.3334C37.7014 35.3333 38 35.632 38 36V38C38 38.368 37.7014 38.6667 37.3334 38.6667Z",
    fill: "#2395EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3334 38.6667H39.3334C38.9654 38.6667 38.6667 38.368 38.6667 38V36C38.6667 35.632 38.9654 35.3333 39.3334 35.3333H41.3334C41.7014 35.3333 42 35.632 42 36V38C42 38.368 41.7014 38.6667 41.3334 38.6667Z",
    fill: "#2395EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3334 34.6667H31.3334C30.9654 34.6667 30.6667 34.368 30.6667 34V32C30.6667 31.632 30.9654 31.3333 31.3334 31.3333H33.3334C33.7014 31.3333 34 31.632 34 32V34C34 34.368 33.7014 34.6667 33.3334 34.6667Z",
    fill: "#2395EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3334 34.6667H35.3334C34.9654 34.6667 34.6667 34.368 34.6667 34V32C34.6667 31.632 34.9654 31.3333 35.3334 31.3333H37.3334C37.7014 31.3333 38 31.632 38 32V34C38 34.368 37.7014 34.6667 37.3334 34.6667Z",
    fill: "#2395EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3334 34.6667H39.3334C38.9654 34.6667 38.6667 34.368 38.6667 34V32C38.6667 31.632 38.9654 31.3333 39.3334 31.3333H41.3334C41.7014 31.3333 42 31.632 42 32V34C42 34.368 41.7014 34.6667 41.3334 34.6667Z",
    fill: "#2395EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3334 30.6667H39.3334C38.9654 30.6667 38.6667 30.368 38.6667 30V28C38.6667 27.632 38.9654 27.3333 39.3334 27.3333H41.3334C41.7014 27.3333 42 27.632 42 28V30C42 30.368 41.7014 30.6667 41.3334 30.6667Z",
    fill: "#2395EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 38.6667H43.3334C42.9654 38.6667 42.6667 38.368 42.6667 38V36C42.6667 35.632 42.9654 35.3333 43.3334 35.3333H45.3334C45.7014 35.3333 46 35.632 46 36V38C46 38.368 45.7014 38.6667 45.3334 38.6667Z",
    fill: "#2395EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_92"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(24 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker);
export default __webpack_public_path__ + "static/media/docker.1432d880dc7a731744c8b433d66cbc88.svg";
export { ForwardRef as ReactComponent };